import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card, Icon, Stack, Text,
} from '@piwikpro/ui-components';
import styles from './FailedContent.module.css';

const FailedContent = () => {
  const { t } = useTranslation(['administration']);

  return (
    <div className={styles.wrapper}>
      <Card>
        <Card.Section subdued>
          <Stack vertical horizontalAlignment="middle" verticalAlignment="center" spacing="extraNarrow">
            <Stack.Item>
              <Icon color="red" name="exclamation-mark-circle" size="medium" />
            </Stack.Item>
            <Stack.Item>
              <Text color="Red" dataId="TextStyle">
                {t('trackerSettings.load.failed')}
              </Text>
            </Stack.Item>
          </Stack>
        </Card.Section>
      </Card>
    </div>
  );
};

export default FailedContent;
